import {
  Component,
  ComponentFactoryResolver,
  OnInit,
  ViewContainerRef,
  OnDestroy,
} from '@angular/core';
import { Router } from '@angular/router';
import { BetlimitService } from '../../../../services/betlimit.service';
import { TranslateService } from '@ngx-translate/core';
import { LobbyConstant } from '../../../../constant/lobby.constant';
import { CommonLayoutComponent } from '../../../common/core/common.layout.component';
import { PageConstant } from '../../../../constant/page.constant';
import { LoadGameService } from '../../../../services/load.game.service';
import { GIInfoService } from '../../../../services/giinfo.service';
import { ErrorPopupService } from '../../../../services/error.popup.service';
import { UtilService } from '../../../../util/UtilService';
import { FirebaseAnalyticsService } from '../../../../services/firebaseanalytics.service';
import { UserService } from '../../../../services/user.service';

@Component({
    templateUrl: '../../../../template/noop.template.html',
    standalone: false
})
export class FCGLayoutComponent
  extends CommonLayoutComponent
  implements OnInit, OnDestroy
{
  public fcbLoadComplete = false;
  public fcbLoadStarted = false;

  private loadBaccaratSubscription;

  constructor(
    public giInfoService: GIInfoService,
    public betLimitService: BetlimitService,
    public router: Router,
    public translate: TranslateService,
    public loadGameService: LoadGameService,
    public componentFactoryResolver: ComponentFactoryResolver,
    public viewContainerRef: ViewContainerRef,
    public errorPopupService: ErrorPopupService,
    public utilService: UtilService,
    public firebaseAnalyticsServices: FirebaseAnalyticsService,
    public userService: UserService
  ) {
    super(
      giInfoService,
      betLimitService,
      translate,
      router,
      loadGameService,
      componentFactoryResolver,
      viewContainerRef,
      errorPopupService,
      utilService,
      firebaseAnalyticsServices,
      userService
    );
    this.pageName = PageConstant.FCG;
    this.currentMenuName = PageConstant.FCG;
  }

  ngOnInit() {
    super.ngOnInit();
    // this.fc21Array = this.utilService.isDesktopView ? [...LobbyConstant.FC21] : [...LobbyConstant.MOBLEFC21];
    this.fcbArray = [...LobbyConstant.FCB];
    document.body.style.overflow = 'hidden';
    this.loadGameService.removeAllItem();
    this.loadGameService.addItem('2', 'LANG00254');
    this.fcbLoadComplete = false;
    this.fcbLoadStarted = false;
    this.initGIInfo();
  }

  init() {}

  onMenuLoaded(event) {
    // console.log('ON MENU LOADED EVENT');
    if (!this.fcbLoadStarted) {
      this.fcbLoadStarted = true;
      this.loadBaccaratManifest();
    }
  }

  loadBaccaratManifest() {}

  onBaccaratLoaded = (event) => {
    if (!this.fcbLoadComplete) {
      this.fcbLoadComplete = true;
      this.utilService.loadMiscManifest();
    }
  };

  subscribeBaccaratLoad() {
    if (this.loadBaccaratSubscription) {
      this.loadBaccaratSubscription.unsubscribe();
    }
    this.loadBaccaratSubscription = this.utilService.loadBaccarat.subscribe(
      (event) => {
        this.loadBaccaratSubscription.unsubscribe();
        this.onBaccaratLoaded(event);
      }
    );
  }

  ngOnDestroy(): void {
    if (this.loadBaccaratSubscription) {
      this.loadBaccaratSubscription.unsubscribe();
    }
    super.ngOnDestroy();
  }
}
